import { useState } from 'react';
import { useToast } from '@shared/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { ImportHistoryApiAdapter } from '../adapters/ImportHistoryApiAdapter';
import type { ImportHistoryFilters } from '../adapters/ImportHistoryApiAdapter';

export const useExportImportHistory = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { toast } = useToast();
  const { t } = useTranslation('shopsModule');

  const exportToExcel = async (filters: ImportHistoryFilters = {}) => {
    setIsExporting(true);
    try {
      const httpClient = createHttpClient(apiClientWH);
      const adapter = new ImportHistoryApiAdapter(httpClient);
      const urlFile = await adapter.exportToExcel(filters);
      if (urlFile) {
        window.open(urlFile, '_blank');
        toast({
          title: t('importHistory.export.successTitle', 'Exportación exitosa'),
          description: t(
            'importHistory.export.successDescription',
            'El archivo se ha generado correctamente.'
          ),
          variant: 'default',
        });
      } else {
        throw new Error('No se recibió URL del archivo');
      }
    } catch (error: any) {
      toast({
        title: t('importHistory.export.errorTitle', 'Error al exportar'),
        description:
          error?.message ||
          t('importHistory.export.errorUnexpected', 'Error inesperado al exportar.'),
        variant: 'destructive',
      });
    } finally {
      setIsExporting(false);
    }
  };

  return { exportToExcel, isExporting };
};
